import { Modal } from 'antd'

import styles from './B2bCustomModal.module.scss'

const getModalProps = ({ isFullScreen = false, ...props }) => {
  if (isFullScreen) {
    return {
      ...props,
      wrapClassName: styles.modal,
      footer: null,
      closable: false,
    }
  }

  return props
}

interface B2bCustomModalProps {
  isFullScreen?: boolean
}

const B2bCustomModal = (props: B2bCustomModalProps) => {
  const modalProps = getModalProps(props)

  return <Modal {...modalProps} />
}

export default B2bCustomModal
